import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../../styles';

const styles = css`
  .ProductCardsDoubleWide {
    overflow: hidden;
    padding: 30px;
    position: relative;
    background-color: ${colors.white};
    @media (min-width: 768px) {
      padding: 15px 0 150px 0;
    }
  }
  h2 {
    text-align: center;
    width: 100%;
    display: block;
    ::after {
      content: '';
      display: block;
      margin: 15px auto 20px auto;
      width: 125px;
      height: 2px;
      background-color: #C1EE4A;
      @media (min-width: 992px) {
        margin: 35px auto 48px auto;
      }
    }
    .ProductCardsDoubleWide_title {
      font-family: ${typography.Condensed};
      color: ${colors.brand8};
      font-weight: 700;
      text-transform: uppercase;
      display: block;
      width: 100%;
      font-size: 22px;
    }
    .ProductCardsDoubleWide_subtitle {
      font-family: ${typography.Serif};
      font-weight: 500;
      text-transform: capitalize;
      display: block;
      width: 100%;
      font-size: 35px;
      @media (min-width: 992px) {
        font-size: 60px;
      }
    }
  }
  .ProductCardsDoubleWide_card_list {
    @media (min-width: 992px) {
      display: grid;
      flex-direction: row;
      column-count: 2;
      gap: 4px;
      width: 100%;
      grid-template-columns: repeat(2, 1fr);
      max-width: 2000px;
      margin: 0 auto;
    }
  }
  .ProductCardsDoubleWide_card_item {
    margin: 0 0 10px 0;
    @media (min-width: 992px) {
      margin: 0;
      position: relative;
      ::after {
        content: '';
        display: block;
        position: absolute;
        z-index: 1;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: linear-gradient(153.7deg, rgba(172,172,172,0) 0%, rgba(63,63,63,0.6) 55.43%, #2B2B2B 100%);
      }
    }
  }
  .ProductCardsDoubleWide_card_item_image {
    max-width: 100%;
  }
  .ProductCardsDoubleWide_card_item_text {
    margin: 20px 0 40px 0;
    padding: 0 20px 0 0;
    z-index: 2;
    @media (min-width: 992px) {
      position: absolute;
      bottom: 10px;
      left: 60px;
      padding: 0 10px 0 0;
    }
    @media (min-width: 1400px) {
      bottom: 30px;
      left: 60px;
      padding: 0 60px 0 0;
    }
    p {
      font-family: ${typography.Condensed};
      color: ${colors.body};
      font-weight: 400;
      text-transform: uppercase;
      vertical-align: bottom;
      margin: 0 0 15px 0;
      font-size: 24px;
      @media (min-width: 992px) {
        color: ${colors.white};
        font-weight: 400;
      }
      @media (min-width: 1400px) {
        font-weight: 700;
        font-size: 29px;
      }
      :last-of-type {
        ::after {
          content: '';
          display: block;
          margin: 15px 0 20px 0;
          width: 75px;
          height: 2px;
          background-color: #C1EE4A;
          @media (min-width: 992px) {
            margin: 15px 0 10px 0;
          }
          @media (min-width: 1400px) {
            margin: 15px 0 25px 0;
          }
        }
      }
    }
  }
`;

function ProductCardsDoubleWide({ content }) {
  return (
    <div className={styles}>
      <div className="ProductCardsDoubleWide">
        <div className="d-lg-flex flex-lg-column">
          {
            get(content, '[0]title') && get(content, '[0]subtitle') &&
            <h2>
              {
                get(content, '[0]title') &&
                <span className="ProductCardsDoubleWide_title">{get(content, '[0]title')}</span>
              }
              {
                get(content, '[0]subtitle') &&
                <span className="ProductCardsDoubleWide_subtitle">{get(content, '[0]subtitle')}</span>
              }
            </h2>
          }
          <div className="ProductCardsDoubleWide_card_list">
            {
              get(content, '[0]card_list').map(item => (
                <div className="ProductCardsDoubleWide_card_item" key={item._id}>
                  <Image
                    className="ProductCardsDoubleWide_card_item_image"
                    src={get(item, 'image.contentUrl')}
                    width={1000}
                    height={1000}
                    alt={get(item, 'image.name', get(item, 'image.caption'))}
                  />
                  <div className="ProductCardsDoubleWide_card_item_text" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'message'))} />
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}

ProductCardsDoubleWide.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

ProductCardsDoubleWide.defaultProps = {
};

export const sectionName = 'Home Conent';

export default ProductCardsDoubleWide;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/ProductCardsDoubleWide.section.js